import { render } from "./ChildrenAttendanceList.vue?vue&type=template&id=73d66797&ts=true"
import script from "./ChildrenAttendanceList.vue?vue&type=script&lang=ts"
export * from "./ChildrenAttendanceList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__